const actions = {
    /* Number formats */
    NUMBER_FORMAT_SET: 'NUMBER_FORMAT_SET',
    NUMBER_FORMAT_CREATE_REQUEST: 'NUMBER_FORMAT_CREATE_REQUEST',
    NUMBER_FORMAT_CREATE_SUCCESS: 'NUMBER_FORMAT_CREATE_SUCCESS',
    NUMBER_FORMAT_CREATE_FAIL: 'NUMBER_FORMAT_CREATE_FAIL',
    NUMBER_FORMAT_READ_LIST_REQUEST: 'NUMBER_FORMAT_READ_LIST_REQUEST',
    NUMBER_FORMAT_READ_LIST_SUCCESS: 'NUMBER_FORMAT_READ_LIST_SUCCESS',
    NUMBER_FORMAT_READ_LIST_FAIL: 'NUMBER_FORMAT_READ_LIST_FAIL',
    NUMBER_FORMAT_READ_REQUEST: 'NUMBER_FORMAT_READ_REQUEST',
    NUMBER_FORMAT_READ_SUCCESS: 'NUMBER_FORMAT_READ_SUCCESS',
    NUMBER_FORMAT_READ_FAIL: 'NUMBER_FORMAT_READ_FAIL',
    NUMBER_FORMAT_UPDATE_REQUEST: 'NUMBER_FORMAT_UPDATE_REQUEST',
    NUMBER_FORMAT_UPDATE_SUCCESS: 'NUMBER_FORMAT_UPDATE_SUCCESS',
    NUMBER_FORMAT_UPDATE_FAIL: 'NUMBER_FORMAT_UPDATE_FAIL',
    NUMBER_FORMAT_DELETE_REQUEST: 'NUMBER_FORMAT_DELETE_REQUEST',
    NUMBER_FORMAT_DELETE_SUCCESS: 'NUMBER_FORMAT_DELETE_SUCCESS',
    NUMBER_FORMAT_DELETE_FAIL: 'NUMBER_FORMAT_DELETE_FAIL',
    /* OTHERS */
    NUMBER_FORMAT_RESET_STATE: 'NUMBER_FORMAT_RESET_STATE',
    NUMBER_FORMAT_TOGGLE_DRAWER: 'NUMBER_FORMAT_TOGGLE_DRAWER',

    /* NUMBER_FORMATS */
    setNumberFormat: number_format => ({
        type: actions.NUMBER_FORMAT_SET,
        number_format,
    }),
    createNumberFormat: request => ({
        type: actions.NUMBER_FORMAT_CREATE_REQUEST,
        request,
    }),
    readNumberFormatList: request => ({
        type: actions.NUMBER_FORMAT_READ_LIST_REQUEST,
        request,
    }),
    readNumberFormat: id => ({
        type: actions.NUMBER_FORMAT_READ_REQUEST,
        id,
    }),
    updateNumberFormat: (id, request) => ({
        type: actions.NUMBER_FORMAT_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteNumberFormat: id => ({
        type: actions.NUMBER_FORMAT_DELETE_REQUEST,
        id,
    }),

    /* OTHERS */
    resetState: () => ({
        type: actions.NUMBER_FORMAT_RESET_STATE,
    }),

    toggleNumberFormatDrawer: (visible, mode, drawerProps) => ({
        type: actions.NUMBER_FORMAT_TOGGLE_DRAWER,
        visible,
        mode, // 'create', 'update',
        drawerProps,
        // {transactionType: 'sale_payment', initialTypeValue: 'official_recipt', enforceType: true}
    }),
};
export default actions;
